import { Link } from 'gatsby';
import tw from 'twin.macro';

const Button = tw(
  Link
)`rounded-lg py-3 px-4 text-base md:text-lg inline-flex items-center space-x-1 shadow-none bg-gray-100 text-gray-900 transition-colors duration-100 ease-in outline-none focus:ring focus:ring-secondary-400 hover:bg-gray-300 hover:shadow`;

export default Button
